import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import {
    getItemSummaryCatalogId,
    getItemSummaryCatalogStatus,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getRegistrationDeclined } from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import { useAppSelector } from '@/redux/hooks';
import BidConsoleOpener from '@/components/BidConsoleOpener/BidConsoleOpener';
import ItemCardLiveBidButton from '@/components/GridItemCard/Card/components/ItemCardBidButton/ItemCardLiveBidButton';
import styled from 'styled-components';

export type CardBiddingProps = { itemId: number; showLiveBidButton: boolean };

const CardBidding = ({ itemId, showLiveBidButton }: CardBiddingProps) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const catalogStatus = useAppSelector((state) => getItemSummaryCatalogStatus(state, itemId));

    const declined = useAppSelector((state) => getRegistrationDeclined(state, catalogId));

    return (
        <>
            {catalogStatus === 'live' && !declined && (
                <ButtonGrid data-testid="myItemsCardBidding">
                    <BidConsoleOpener catalogId={catalogId}>
                        <StyledEnterAuctionButton
                            aria-label="Enter live auction button"
                            data-testid="enter-auction-container"
                            size="sm"
                            style="critical"
                            variant="filled"
                        >
                            <FormattedMessage id="enter_live_auction_mobile" />
                        </StyledEnterAuctionButton>
                    </BidConsoleOpener>
                </ButtonGrid>
            )}
            {showLiveBidButton && (
                <ButtonGrid data-testid="myItemsCardBidding">
                    <ItemCardLiveBidButton itemId={itemId} />
                </ButtonGrid>
            )}
        </>
    );
};

export default CardBidding;

const ButtonGrid = styled.section`
    grid-area: bidButtonForLiveItem;
`;

const StyledEnterAuctionButton = styled(Button)`
    width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        width: 211px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        width: 211px;
    }
    @media (max-width: 375px) {
        width: 211px;
    }
`;
